import "./TradeSpreadSummary.scss";
import {ClickTarget} from "./ClickTarget";
import {IOnChanges, IOnChangesObject, IOnInit} from "angular";
import {Contract} from "../../../../portfolio/templates/ticket/place-order-wizard/models/Contract";
import {PriceStrategy} from "../../../inputs/price/input/PriceStrategy";
import {SpreadSummary} from "../../../../types/OrderSpread";
import {PriceStrategyService} from "../../../inputs/price/service/PriceStrategyService";
import {UserConfig} from "../../../../types/UserConfig";

export const TradeSpreadSummary = "tfTradeSpreadSummary";

export function tradeSpreadSummary() {
    return {
        templateUrl: "app/components/trade/trade-detail/spread/TradeSpreadSummary.html",
        transclude: true,
        bindings: {
            spread: "<",
            contract: "<",
            onClick: "&"
        },
        controller: TradeSpreadSummaryController,
        controllerAs: "ctrl"
    };
}

export class TradeSpreadSummaryController implements IOnInit, IOnChanges {

    public spread: SpreadSummary;
    public contract: Contract;
    public onClick: Function;

    public strategy: PriceStrategy;
    public showCalculatedVolatility: boolean;

    private strategyService: PriceStrategyService;

    /** @ngInject */
    public constructor(priceStrategyService: PriceStrategyService, private userConfig: UserConfig) {
        this.strategyService = priceStrategyService;
        this.showCalculatedVolatility = userConfig.branding === 'GAME';
    }

    public $onInit() {
        if (this.spread != null) {
            this.strategy = this.strategyService.forCode(this.spread.code);
        }
    }

    public $onChanges(changes: IOnChangesObject): void {
        if (changes.spread != null && !changes.spread.isFirstChange() && this.spread != null) {
            this.strategy = this.strategyService.forCode(this.spread.code);
        }
    }

    public bidClick() {
        this.onClick({ target: ClickTarget.BID });
    }

    public askClick() {
        this.onClick({ target: ClickTarget.ASK });
    }
}
